
export const ObtenerDepartamentos = () => {
    const data = new FormData();
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/departamentos.php?funcion=obtenerDepartamentos',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}
export const ObtenerTiposUsuario = () => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/usuarios.php?funcion=tiposUsuario',{
            method:'POST',
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}
export const GuardarDepartamento = (departamento, idDireccion, idDepartamento, idDepartamentoPadre) => {
    const data = new FormData();
    data.append('departamento', departamento)
    data.append('idDepartamento', idDepartamento)
    data.append('idDireccion', idDireccion)
    data.append('idDepartamentoPadre', idDepartamentoPadre)
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/departamentos.php?funcion=agregarDepartamento',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}
export const EliminarDepartamento = (idDepartamento) => {
    const data = new FormData();
    data.append('idDepartamento', idDepartamento)
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/departamentos.php?funcion=eliminarDepartamento',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}